import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import ENVIRONMENT from '@/environments/environment';

export const chopIonicApp = createApi({
  reducerPath: 'chopIonicApp',
  baseQuery: fetchBaseQuery({
    baseUrl: ENVIRONMENT.BASE_URL,
  }),
  endpoints: (builder) => ({}),
});
